import { getRequest, postRequest } from "@/common/config/realTimeRequest.js";
// 实时数据库登录
export const loginRealTime=()=>{
    getRequest("/api/userlogin/",{user:"administrator",pass:"Qazwsx123"}).then((res)=>{
        if (res.code == 0) {
            sessionStorage.setItem("realTimeToken", res.token);
        }
    })
}